import ReactDOM from 'react-dom';
import App from './App';
import 'antd/dist/antd.less';
import './styles/global.less';
import { Provider } from 'react-redux';
import { store } from './models/store';
import { initGdp } from './common/gdp';
import { initReportModule } from './utils/report';
import { setLanguageProvider } from './api/ajax';

initGdp();
initReportModule();

// 注入语言 header 供应者：所有 ajax 请求自动带上 language header，
// 避免后端 @RequestHeader('language') 校验失败。
setLanguageProvider(() => store.getState()?.LocaleModel?.serverLang);

function render(props) {
  const { container } = props;
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    container ? container.querySelector('#root') : document.querySelector('#root')
  );
}

if (!window.__POWERED_BY_QIANKUN__) {
  render({});
}
